/* tslint:disable */
/* eslint-disable */
/**
 * ReD Admin API Spec
 * ReD中途企業向けサイト用API
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: info@redesigner.jp
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { GetAccount200ResponseAgent } from './GetAccount200ResponseAgent';
import {
    GetAccount200ResponseAgentFromJSON,
    GetAccount200ResponseAgentFromJSONTyped,
    GetAccount200ResponseAgentToJSON,
} from './GetAccount200ResponseAgent';
import type { GetAccount200ResponseFeatureFlags } from './GetAccount200ResponseFeatureFlags';
import {
    GetAccount200ResponseFeatureFlagsFromJSON,
    GetAccount200ResponseFeatureFlagsFromJSONTyped,
    GetAccount200ResponseFeatureFlagsToJSON,
} from './GetAccount200ResponseFeatureFlags';
import type { GetAccount200ResponsePlan } from './GetAccount200ResponsePlan';
import {
    GetAccount200ResponsePlanFromJSON,
    GetAccount200ResponsePlanFromJSONTyped,
    GetAccount200ResponsePlanToJSON,
} from './GetAccount200ResponsePlan';

/**
 * 
 * @export
 * @interface GetAccount200Response
 */
export interface GetAccount200Response {
    /**
     * ステータス
     * @type {number}
     * @memberof GetAccount200Response
     */
    status: number;
    /**
     * メッセージ
     * @type {string}
     * @memberof GetAccount200Response
     */
    message: string;
    /**
     * 社員コード
     * @type {string}
     * @memberof GetAccount200Response
     */
    employeeCode: string;
    /**
     * email
     * @type {string}
     * @memberof GetAccount200Response
     */
    employeeEmail: string;
    /**
     * 氏名
     * @type {string}
     * @memberof GetAccount200Response
     */
    employeeName: string;
    /**
     * プロフィール画像パス
     * @type {string}
     * @memberof GetAccount200Response
     */
    profileImagePath: string;
    /**
     * SlackID
     * @type {string}
     * @memberof GetAccount200Response
     */
    slackId: string;
    /**
     * 電話番号
     * @type {string}
     * @memberof GetAccount200Response
     */
    phoneNumber: string;
    /**
     * 企業コード
     * @type {string}
     * @memberof GetAccount200Response
     */
    companyCode: string;
    /**
     * 企業名
     * @type {string}
     * @memberof GetAccount200Response
     */
    companyName: string;
    /**
     * 企業ロゴ画像パス
     * @type {string}
     * @memberof GetAccount200Response
     */
    companyLogoImagePath: string;
    /**
     * 企業タイプ 0:一般 1:運営
     * @type {number}
     * @memberof GetAccount200Response
     */
    companyType: number;
    /**
     * 公開フラグ 1:非公開  2:公開
     * @type {number}
     * @memberof GetAccount200Response
     */
    publicFlg: number;
    /**
     * 
     * @type {GetAccount200ResponsePlan}
     * @memberof GetAccount200Response
     */
    plan: GetAccount200ResponsePlan;
    /**
     * 
     * @type {GetAccount200ResponseAgent}
     * @memberof GetAccount200Response
     */
    agent: GetAccount200ResponseAgent;
    /**
     * 代理状態 1:代理中 0:通常
     * @type {number}
     * @memberof GetAccount200Response
     */
    substituteStatus?: number;
    /**
     * 代理対応担当フラグ
     * @type {boolean}
     * @memberof GetAccount200Response
     */
    isSubstituteSupport?: boolean;
    /**
     * 
     * @type {GetAccount200ResponseFeatureFlags}
     * @memberof GetAccount200Response
     */
    featureFlags?: GetAccount200ResponseFeatureFlags;
}

/**
 * Check if a given object implements the GetAccount200Response interface.
 */
export function instanceOfGetAccount200Response(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "status" in value;
    isInstance = isInstance && "message" in value;
    isInstance = isInstance && "employeeCode" in value;
    isInstance = isInstance && "employeeEmail" in value;
    isInstance = isInstance && "employeeName" in value;
    isInstance = isInstance && "profileImagePath" in value;
    isInstance = isInstance && "slackId" in value;
    isInstance = isInstance && "phoneNumber" in value;
    isInstance = isInstance && "companyCode" in value;
    isInstance = isInstance && "companyName" in value;
    isInstance = isInstance && "companyLogoImagePath" in value;
    isInstance = isInstance && "companyType" in value;
    isInstance = isInstance && "publicFlg" in value;
    isInstance = isInstance && "plan" in value;
    isInstance = isInstance && "agent" in value;

    return isInstance;
}

export function GetAccount200ResponseFromJSON(json: any): GetAccount200Response {
    return GetAccount200ResponseFromJSONTyped(json, false);
}

export function GetAccount200ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetAccount200Response {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'status': json['status'],
        'message': json['message'],
        'employeeCode': json['employee_code'],
        'employeeEmail': json['employee_email'],
        'employeeName': json['employee_name'],
        'profileImagePath': json['profile_image_path'],
        'slackId': json['slack_id'],
        'phoneNumber': json['phone_number'],
        'companyCode': json['company_code'],
        'companyName': json['company_name'],
        'companyLogoImagePath': json['company_logo_image_path'],
        'companyType': json['company_type'],
        'publicFlg': json['public_flg'],
        'plan': GetAccount200ResponsePlanFromJSON(json['plan']),
        'agent': GetAccount200ResponseAgentFromJSON(json['agent']),
        'substituteStatus': !exists(json, 'substitute_status') ? undefined : json['substitute_status'],
        'isSubstituteSupport': !exists(json, 'is_substitute_support') ? undefined : json['is_substitute_support'],
        'featureFlags': !exists(json, 'feature_flags') ? undefined : GetAccount200ResponseFeatureFlagsFromJSON(json['feature_flags']),
    };
}

export function GetAccount200ResponseToJSON(value?: GetAccount200Response | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'status': value.status,
        'message': value.message,
        'employee_code': value.employeeCode,
        'employee_email': value.employeeEmail,
        'employee_name': value.employeeName,
        'profile_image_path': value.profileImagePath,
        'slack_id': value.slackId,
        'phone_number': value.phoneNumber,
        'company_code': value.companyCode,
        'company_name': value.companyName,
        'company_logo_image_path': value.companyLogoImagePath,
        'company_type': value.companyType,
        'public_flg': value.publicFlg,
        'plan': GetAccount200ResponsePlanToJSON(value.plan),
        'agent': GetAccount200ResponseAgentToJSON(value.agent),
        'substitute_status': value.substituteStatus,
        'is_substitute_support': value.isSubstituteSupport,
        'feature_flags': GetAccount200ResponseFeatureFlagsToJSON(value.featureFlags),
    };
}

